var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-agreement"},[_c('pageHeader',{attrs:{"title":"服务协议"}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('iframe',{attrs:{"width":"100%","height":"100%","src":_vm.url,"frameborder":"0"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9ee2da8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/serviceAgreement/index.vue
// module id = null
// module chunks = 